import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {
  MarketoState,
  SalesforceState,
  SlackState,
  WistiaState,
  PardotState,
  WebhooksState,
  State,
  EloquaState,
  SlackPlusSalesforceState,
  EventFieldMappingState
} from './types';

const marketoDefaultState = (): MarketoState => ({
  isMarketoValidateProgramIdLoading: false,
  marketoCampaignFolders: [],
  isMarketoCampaignFoldersLoading: false,
  isMarketoCloneLoading: false,
  isMarketoProgramStatusLoading: false
});

const salesforceDefaultState = (): SalesforceState => ({
  isSalesforceValidateCampaignIdLoading: false,
  isConnectSalesforceCampaignLoading: false,
  isSalesforceCampaignStatusLoading: false
});

const slackDefaultState = (): SlackState => ({
  slackChannels: [],
  isSlackChannelsLoading: false,
  slackChannelError: null,
  isSlackChannelValidationLoading: false
});

const wistiaDefaultState = (): WistiaState => ({
  wistiaProjects: [],
  isWistiaLoading: false
});

const pardotDefaultState = (): PardotState => ({
  isPardotImportLoading: false,
  isPardotExportLoading: false,
  pardotError: null
});

const webhooksDefaultState = (): WebhooksState => ({
  isWebhooksLoading: false,
  webhooks: []
});

const eloquaDefaultState = (): EloquaState => ({
  isEloquaValidateEventFormIdLoading: false,
  isValidEloquaFormConnected: true
});

const slackPlusSalesforceDefaultState = (): SlackPlusSalesforceState => ({
  isSlackPlusSalesforceNotificationsLoading: false,
  slackPlusSalesforceNotifications: []
});

const integrationsActivitySyncDetailsDefaultState = () => ({
  isIntegrationsActivitySyncDetailsLoading: false,
  integrationsActivitySyncDetails: {},
  integrationActivitySyncError: false
});

const eventFieldMappingDefaultState = (): EventFieldMappingState => ({
  eventSourceFields: [],
  isEventSourceFieldLoading: false,
  eventFieldMappings: {},
  prevEventFieldMappings: {},
  eventFieldMappingRowError: {},
  isSaveEventFieldMappingLoading: {}
});

const state: State = {
  ...marketoDefaultState(),
  ...salesforceDefaultState(),
  ...slackDefaultState(),
  ...wistiaDefaultState(),
  ...pardotDefaultState(),
  ...webhooksDefaultState(),
  ...eloquaDefaultState(),
  ...slackPlusSalesforceDefaultState(),
  ...integrationsActivitySyncDetailsDefaultState(),
  ...eventFieldMappingDefaultState()
};

export default {
  actions,
  mutations,
  state,
  getters,
  namespaced: true
};
